import { Component } from '@angular/core';
import * as formjs from 'formiojs';
// import { Formio } from 'formiojs';
// import { Formio } from 'formiojs/full';
// import { Components, BaseComponen } from '@formio/angular';
// import Components from 'formiojs/build/components/index’;
// import { BaseComponent } from ‘formiojs/build/components/base/Base’;

@Component({
  selector: 'app-counter-component',
  templateUrl: './counter.component.html'
})
export class CounterComponent {
  public currentCount = 0;

  public incrementCounter() {
    this.currentCount++;
  }

  constructor(){
   // Components.setComponent()
  }
}
